import PropTypes from 'react-proptypes';

export default {
  app: 'maandlasten-bij-aflossen',
  pages: [
    'landing',
    'final',
  ],
  framed: false,
  recalculating: null,
  syncing: false,
  broken: false,
  settings: {},
  input: {
    next_step_text: 'Berekenen',
    info_box: null,
    tab: null,
    show_disclaimer: false,
    amount: null,
    years: null,
  },
  output: {
    errors: {},
  },
};

const {
  number,
  shape,
} = PropTypes;

export const shapeInput = shape({
  amount: number,
  years: number,
});

export const shapeOutput = shape({});
